<div
    class="iphorm-element-wrap iphorm-element-wrap-captcha iphorm_41_9-element-wrap iphorm-clearfix iphorm-labels-inside iphorm-element-required iphorm-element-error">
    <div class="iphorm-element-spacer iphorm-element-spacer-captcha iphorm_41_9-element-spacer">
        <label *ngIf="!captcha.value" for="iphorm_41_9_625eb1ce80647" class="iphorm_41_9-outer-label">کد امنیتی
            زیر را وارد نمایید<span class="iphorm-required">*</span></label>
        <div class="iphorm-input-wrap iphorm-input-wrap-captcha iphorm_41_9-input-wrap">
            <input #captcha="ngModel" required class="iphorm-element-captcha  iphorm_41_9"
                id="iphorm_41_9_625eb1ce80647" type="text" [(ngModel)]="captchaInput" name="captcha" value="">
        </div>
        <div class="iphorm-captcha-image-wrap iphorm-clearfix iphorm_41_9-captcha-image-wrap">
            <div class="ifb-captcha-image-inner">
                <span (click)="generateCaptcha()"
                    style="text-align: center; user-select: none; display: inline-block; width: 155px; height: 35px; background-color: #fff;">{{generatedCaptcha}}</span>
                <!-- <img width="115" height="40" id="iphorm-captcha-image-iphorm_41_9_625eb1ce80647"
                    class="iphorm-captcha-image"
                    src="https://aban.net/apps/iphorm-form-builder/includes/captcha.php?c=eyJ1bmlxSWQiOiI2MjVlYjFjZTgwNjQ3IiwidG1wRGlyIjoiXC90bXBcLyIsIm9wdGlvbnMiOnsibGVuZ3RoIjoiNSIsIndpZHRoIjoiMTE1IiwiaGVpZ2h0IjoiNDAiLCJiZ0NvbG91ciI6IiNGRkZGRkYiLCJ0ZXh0Q29sb3VyIjoiIzIyMjIyMiIsImZvbnQiOiJUeXBpc3QudHRmIiwibWluRm9udFNpemUiOiIxMiIsIm1heEZvbnRTaXplIjoiMTkiLCJtaW5BbmdsZSI6IjAiLCJtYXhBbmdsZSI6IjIwIn19&amp;t=1650373070.5352"
                    alt="CAPTCHA"> -->
            </div>
        </div>

        <div [hidden]="(captcha.valid || captcha.pristine) && !form.submitted" class="iphorm-errors-wrap">
            <div class="iphorm-errors-list iphorm-clearfix">
                <div *ngIf="form?.controls?.captcha?.errors && form.controls.captcha.errors.invalidCaptcha"
                    class="iphorm-error" style="margin-right: 3px;">مقدار وارد شده اشتباه
                    است</div>
                <div *ngIf="captcha.errors && captcha.errors.invalidCaptcha" class="iphorm-error">کپچا وارد شده اشتباه
                    است</div>
            </div>
        </div>
    </div>
</div>
<!-- <div class="iphorm-hidden">
    <label>این قسمت نباید خالی رها شود.<input type="text" name="iphorm_41_0"></label>
</div> -->